// eslint-disable-next-line import/no-cycle
import { adminApi } from '../includes/contentManagementApi';

/** Must match backend `USER_ROLES_ENUM_NAME` */
export const USER_ROLES_ENUM_NAME = 'user-roles';

/** Must match backend `DEFAULT_USER_ROLE` */
export const DEFAULT_USER_ROLE = 'user';

/** Must match backend `TENANT_ROLE_ADMIN` */
export const TENANT_ROLE_ADMIN = 'admin';

/** Must match backend `TENANT_ROLE_COMPANY_SUPERUSER` */
export const TENANT_ROLE_COMPANY_SUPERUSER = 'companySuperuser';

/** Must match backend `TENANT_ROLE_TEAM_LEADER` (effective when user leads a team) */
export const TENANT_ROLE_TEAM_LEADER = 'teamLeader';

export default {
  /**
   * Get all enum types
   * @param {boolean} activeOnly - When true, server may filter to active values only (if supported).
   *   Use string 'true'|'false' in the query so `false` is never dropped by axios (booleans are omitted).
   */
  getAllEnumTypes(activeOnly = true) {
    return adminApi.get('/enum-manager', {
      params: { activeOnly: activeOnly ? 'true' : 'false' },
    });
  },

  /**
   * Get a specific enum type by name
   * @param {string} name - Name of the enum type
   * @param {boolean} activeOnly - When false, include inactive enum values (required for Enum Manager edit UI).
   */
  getEnumType(name, activeOnly = true) {
    const params = { activeOnly: activeOnly ? 'true' : 'false' };
    const path = `/enum-manager/${encodeURIComponent(name)}`;
    return adminApi.get(path, { params });
  },

  /**
   * Create a new enum type
   * @param {Object} enumData - The enum data
   * @param {string} enumData.name - Name of the enum type
   * @param {Array} enumData.values - Initial values for the enum
   * @param {string} enumData.description - Description of the enum
   */
  createEnumType(enumData) {
    return adminApi.post('/enum-manager', enumData);
  },

  /**
   * Add a new value to an enum type
   * @param {string} enumName - Name of the enum type
   * @param {Object} valueData - The value data
   * @param {string} valueData.value - The value to add
   * @param {string} valueData.description - Description of the value
   */
  addEnumValue(enumName, valueData) {
    return adminApi.post(`/enum-manager/${enumName}/values`, valueData);
  },

  /**
   * Deactivate a value in an enum type
   * @param {string} enumName - Name of the enum type
   * @param {string} value - The value to deactivate
   */
  deactivateEnumValue(enumName, value) {
    return adminApi.patch(`/enum-manager/${enumName}/values/${value}/deactivate`);
  },

  /**
   * Activate a value in an enum type
   * @param {string} enumName - Name of the enum type
   * @param {string} value - The value to activate
   */
  activateEnumValue(enumName, value) {
    return adminApi.patch(`/enum-manager/${enumName}/values/${value}/activate`);
  },

  /**
   * Delete an enum type
   * @param {string} name - Name of the enum type
   */
  deleteEnumType(name) {
    return adminApi.delete(`/enum-manager/${name}`);
  },

  /**
   * Delete a single value from an enum type
   * @param {string} enumName
   * @param {string} value - enum value (URL-safe identifier recommended)
   */
  deleteEnumValue(enumName, value) {
    return adminApi.delete(`/enum-manager/${enumName}/values/${value}`);
  },

  /**
   * Preview impact of deleting a user-roles value (users + schemas)
   */
  getUserRoleDeleteImpact(enumName, value) {
    return adminApi.get(`/enum-manager/${enumName}/values/${value}/delete-impact`);
  },
};
